<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <div class="formRow">
            <h4>Width: </h4><input type="text" v-model="$parent.mediaProperty.configuration.width" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive"/>
            <p class="validationMessage" v-if="!$parent.mediaProperty.configuration.width && $parent.mediaProperty.configuration.width !== 0">*This field is required</p>
        </div>
        <div class="formRow"><h4>Header: </h4><input type="text" v-model="$parent.mediaProperty.configuration.header" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive"/></div>
        <div class="formRow"><h4>Header Total: </h4><input type="text" v-model="$parent.mediaProperty.configuration.headerTotal" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive"/></div>
        <div class="formRow">
            <h4>Subheader: </h4>
            <AutoComplete class="valueContainer" :value="$parent.mediaProperty.configuration.subheader"
                :data="attributeList" :onValueChanged="updateAutoCompleteValue"
                :onBlur="autoCompleteSubmit" :placeholder="''" :passThruObject="{obj: $parent.mediaProperty.configuration, property: 'subheader'}"
                internalValueField="code" displayField="code" searchField="code"></AutoComplete>
        </div>
        <div class="formRow"><h4>X-Axis Label*: </h4><input type="text" v-model="$parent.mediaProperty.configuration.xAxisLabel" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive"/></div>
        <div class="formRow">
            <h4>Major Ticks*: </h4><input type="number" v-model="$parent.mediaProperty.configuration.majorTicks" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive"/>
            <p class="validationMessage" v-if="!$parent.mediaProperty.configuration.majorTicks && $parent.mediaProperty.configuration.majorTicks !== 0">*This field is required</p>
            <p class="validationMessage" v-if="$parent.mediaProperty.configuration.majorTicks < 0">*This field must be non-negative</p>
        </div>
        <div class="formRow">
            <h4>Minor Ticks*: </h4><input type="number" v-model="$parent.mediaProperty.configuration.minorTicks" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive"/>
            <p class="validationMessage" v-if="!$parent.mediaProperty.configuration.minorTicks && $parent.mediaProperty.configuration.minorTicks !== 0">*This field is required</p>
            <p class="validationMessage" v-if="$parent.mediaProperty.configuration.minorTicks < 0">*This field must be non-negative</p>
        </div>
        <div class="formRow">
            <h4>Minimum Value*: </h4><input type="number" v-model="$parent.mediaProperty.configuration.minValue" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive"/>
            <p class="validationMessage" v-if="!$parent.mediaProperty.configuration.minValue && $parent.mediaProperty.configuration.minValue !== 0">*This field is required</p>
        </div>
        <div class="formRow">
            <h4>Maximum Value*: </h4><input type="number" v-model="$parent.mediaProperty.configuration.maxValue" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive"/>
            <p class="validationMessage" v-if="!$parent.mediaProperty.configuration.maxValue && $parent.mediaProperty.configuration.maxValue !== 0">*This field is required</p>
        </div>
        <div class="formRow">
            <h4>Fine Print: </h4>
            <AutoComplete class="valueContainer" :value="$parent.mediaProperty.configuration.finePrint"
                :data="attributeList" :onValueChanged="updateAutoCompleteValue"
                :onBlur="autoCompleteSubmit" :placeholder="''" :passThruObject="{obj: $parent.mediaProperty.configuration, property: 'finePrint'}"
                internalValueField="code" displayField="code" searchField="code"></AutoComplete>
        </div>
        <div v-if="$parent.mediaProperty.configuration.measuringTape">
            <div class="formRow"><h4>Show Measuring Tape:</h4>
                <input type="checkbox" v-model="$parent.mediaProperty.configuration.measuringTape.visible" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive">
            </div>
            <div class="grandChildObject" v-if="$parent.mediaProperty.configuration.measuringTape.visible">
                <h4>Measuring Tape Details</h4>
                <div class="formRow">
                    <h4>Start Value: </h4>
                    <AutoComplete class="valueContainer" :value="$parent.mediaProperty.configuration.measuringTape.startValue?.toString()"
                            :data="attributeList" :onValueChanged="updateAutoCompleteValue"
                            :onBlur="autoCompleteSubmit" :placeholder="''" :passThruObject="{obj: $parent.mediaProperty.configuration.measuringTape, property: 'startValue'}"
                            internalValueField="code" displayField="code" searchField="code"></AutoComplete>
                </div>
                <div class="formRow">
                    <h4>End Value: </h4>
                    <AutoComplete class="valueContainer" :value="$parent.mediaProperty.configuration.measuringTape.endValue?.toString()"
                            :data="attributeList" :onValueChanged="updateAutoCompleteValue"
                            :onBlur="autoCompleteSubmit" :placeholder="''" :passThruObject="{obj: $parent.mediaProperty.configuration.measuringTape, property: 'endValue'}"
                            internalValueField="code" displayField="code" searchField="code"></AutoComplete>
                </div>
                <div class="formRow"><h4>Message: </h4><input type="text" v-model="$parent.mediaProperty.configuration.measuringTape.message" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive"/></div>
                <div class="formRow"><h4>Message Alignment: </h4>
                    <select v-model="$parent.mediaProperty.configuration.measuringTape.messageAlignment" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive">
                        <option value=""></option>
                        <option value="left">Left</option>
                        <option value="center">Center</option>
                        <option value="right">Right</option>
                    </select>
                </div>
                <div class="formRow">
                    <h4>Color:</h4>
                    <input type="text" width="100px" v-model="$parent.mediaProperty.configuration.measuringTape.htmlColor" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive"/>
                    <div class="colorSample" :style="{'background': $parent.mediaProperty.configuration.measuringTape.htmlColor, 'background-color': $parent.mediaProperty.configuration.measuringTape.htmlColor}"></div>
                </div>
            </div>
        </div>
        <h4>Legend:</h4>
        <div class="childObject">
            <div class="formRow" v-for="(legendRow, index) in $parent.mediaProperty.configuration.legend" :key="legendRow.color">
                <div class="formRow">
                    <h4>Title*: </h4>
                    <p>{{ legendRow.title }}</p>
                </div>
                <div class="formRow">
                    <h4>Color*: </h4>
                    <span>{{ legendRow.color }}</span>
                    <div class="colorSample" :style="{'background': legendRow.color, 'background-color': legendRow.color}"></div>
                </div>
                <hr v-if="index < $parent.mediaProperty.configuration.legend.length - 1"/>
            </div>
        </div>
        <h4>Bars:</h4>
        <div class="childObject" v-if="attributeList.length">
            <div class="formRow" v-for="(bar, barIndex) in $parent.mediaProperty.configuration.barData" :key="bar.sequence">
                <div class="sequenceButtons" v-if="$parent.mediaProperty.configuration.barData.length > 1">
                    <div class="sequenceMinusButton" @click="sequenceMinus(bar)">
                        <i class="fa-solid fa-angle-up"></i>
                    </div>
                    <div class="sequencePlusButton" @click="sequencePlus(bar)">
                        <i class="fa-solid fa-angle-down"></i>
                    </div>
                </div>
                <div class="formRow">
                    <h4>Segment Groups:</h4>
                </div>
                <div class="grandChildObject">
                    <div class="formRow" v-for="(segmentGroup, segmentGroupIndex) in bar.segmentGroups" :key="segmentGroup.sequence">
                        <div class="sequenceButtons" v-if="bar.segmentGroups.length > 1">
                            <div class="sequenceMinusButton" @click="sequenceMinus(segmentGroup, bar.segmentGroups)">
                                <i class="fa-solid fa-angle-up"></i>
                            </div>
                            <div class="sequencePlusButton" @click="sequencePlus(segmentGroup, bar.segmentGroups)">
                                <i class="fa-solid fa-angle-down"></i>
                            </div>
                        </div>
                        <div class="formRow">
                            <h4>Title*: </h4>
                            <AutoComplete class="valueContainer" :value="segmentGroup.title"
                                        :data="attributeList" :onValueChanged="updateAutoCompleteValue"
                                        :onBlur="autoCompleteSubmit" :placeholder="''" :passThruObject="{obj: segmentGroup, property: 'title'}"
                                        internalValueField="code" displayField="code" searchField="code"></AutoComplete>
                            <p class="validationMessage" v-if="!segmentGroup.title">*This field is required</p>
                        </div>
                        <h4>Segments:</h4>
                        <div class="greatGrandChildObject">
                            <div class="formRow" v-for="(segment, segmentIndex) in segmentGroup.segments" :key="segment.sequence">
                                <div class="sequenceButtons" v-if="segmentGroup.segments.length > 1">
                                    <div class="sequenceMinusButton" @click="sequenceMinus(segment, segmentGroup.segments)">
                                        <i class="fa-solid fa-angle-up"></i>
                                    </div>
                                    <div class="sequencePlusButton" @click="sequencePlus(segment, segmentGroup.segments)">
                                        <i class="fa-solid fa-angle-down"></i>
                                    </div>
                                </div>
                                <div class="formRow">
                                    <h4>Start Value*: </h4>
                                    <AutoComplete class="valueContainer" :value="segment.startValue?.toString()"
                                        :data="attributeList" :onValueChanged="updateAutoCompleteValue"
                                        :onBlur="autoCompleteSubmit" :placeholder="''" :passThruObject="{obj: segment, property: 'startValue'}"
                                        internalValueField="code" displayField="code" searchField="code"></AutoComplete>
                                    <p class="validationMessage" v-if="!segment.startValue && segment.startValue !== 0">*This field is required</p>
                                    <p class="validationMessage" v-if="segment.startValueTooLow">*Value must be higher than chart's Min Value</p>
                                </div>
                                <div class="formRow">
                                    <h4>End Value*: </h4>
                                    <AutoComplete class="valueContainer" :value="segment.endValue?.toString()"
                                        :data="attributeList" :onValueChanged="updateAutoCompleteValue"
                                        :onBlur="autoCompleteSubmit" :placeholder="''" :passThruObject="{obj: segment, property: 'endValue'}"
                                        internalValueField="code" displayField="code" searchField="code"></AutoComplete>
                                    <p class="validationMessage" v-if="!segment.endValue && segment.endValue !== 0">*This field is required</p>
                                    <p class="validationMessage" v-if="segment.endValueTooHigh">*Value must be higher than chart's Min Value</p>
                                </div>
                                <div class="formRow">
                                    <h4>Color*: </h4>
                                    <AutoComplete class="valueContainer" :value="segment.color?.toString()"
                                        :data="attributeList" :onValueChanged="updateAutoCompleteValue"
                                        :onBlur="autoCompleteSubmit" :placeholder="''" :passThruObject="{obj: segment, property: 'color'}"
                                        internalValueField="code" displayField="code" searchField="code"></AutoComplete>
                                    <div class="colorSample" :style="{'background': segment.color, 'background-color': segment.color}"></div>
                                    <p class="validationMessage" v-if="!segment.color">*This field is required</p>
                                </div>
                                <div class="formRow">
                                    <h4>Add color to legend?</h4>
                                    <input type="checkbox" v-model="segment.isInLegend" @change="saveBarChart" :disabled="!$parent.mediaProperty.isActive"/>
                                </div>
                                <div class="formRow" v-if="segment.isInLegend" >
                                    <h4>Legend Title: </h4>
                                    <input type="text" v-model="segment.legendRowTitle" @blur="saveBarChart" :disabled="!$parent.mediaProperty.isActive || segment.duplicateColor"/>
                                    <p class="validationMessage" v-if="segment.duplicateColor">*This color already has a Legend Title</p>
                                </div>
                                <button class="deleteButton" @click="deleteSegment(barIndex, segmentGroupIndex, segmentIndex)" :disabled="!$parent.mediaProperty.isActive"><i class="fas fa-trash-can"></i></button>
                                <hr/>
                            </div>
                            <button class="addRowButton" @click="addSegment(barIndex, segmentGroupIndex)" :disabled="!$parent.mediaProperty.isActive"><i class="fa-circle-plus fas fa-2xl"></i></button>
                        </div>
                        <button class="deleteButton" @click="deleteSegmentGroup(barIndex, segmentGroupIndex)" :disabled="!$parent.mediaProperty.isActive"><i class="fas fa-trash-can"></i></button>
                        <hr/>
                    </div>
                    <button class="addRowButton" @click="addSegmentGroup(barIndex)" :disabled="!$parent.mediaProperty.isActive"><i class="fa-circle-plus fas fa-2xl"></i></button>
                </div>
                <button class="deleteButton" @click="deleteBar(barIndex)" :disabled="!$parent.mediaProperty.isActive"><i class="fas fa-trash-can"></i></button>
                <hr/>
            </div>
            <button class="addRowButton" @click="addBar" :disabled="!$parent.mediaProperty.isActive"><i class="fa-circle-plus fas fa-2xl"></i></button>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import AutoComplete from "@/components/shared/AutoComplete.vue";

export default {
    name: 'BarChartEdit',
    components: { AutoComplete },
    data: function() {
        return {
            attributeList: []
        }
    },
    async mounted() {
        if(!this.$parent.mediaProperty.configuration) {
            this.$parent.mediaProperty.configuration = {
                width: 0,
                header: '',
                headerTotal: '',
                subheader: '',
                xAxisLabel: '',
                majorTicks: 0,
                minorTicks: 0,
                minValue: 0,
                maxValue: 0,
                finePrint: '',
                showMeasuringTape: false,
                legend: [],
                barData: [],
                measuringTape: { visible: false}
            }
        } else {
            let configuration = this.$parent.mediaProperty.configuration;
            
            if(this.$parent.mediaProperty.configuration.measuringTape == null)
                this.$parent.mediaProperty.configuration.measuringTape = { visible: false };

            if(configuration.legend) {
                for(let i = 0; i < configuration.legend.length; i++) {
                    for(let j = 0; j < configuration.barData.length; j++) {
                        configuration.barData.sort((a,b) => {return a.sequence - b.sequence;});
                        for(let k = 0; k < configuration.barData[j].segmentGroups.length; k++) {
                            configuration.barData[j].segmentGroups.sort((a,b) => {return a.sequence - b.sequence;});
                            for(let l = 0; l < configuration.barData[j].segmentGroups[k].segments.length; l++){
                                configuration.barData[j].segmentGroups[k].segments.sort((a,b) => {return a.sequence - b.sequence;});
                                if(configuration.barData[j].segmentGroups[k].segments[l].isInLegend === null)
                                    configuration.barData[j].segmentGroups[k].segments[l].isInLegend = false;
                                if(configuration.legend[i].color === configuration.barData[j].segmentGroups[k].segments[l].color) {
                                    if(!configuration.legend[i].isTitled) {
                                        configuration.barData[j].segmentGroups[k].segments[l].legendRowTitle = configuration.legend[i].title;
                                        configuration.barData[j].segmentGroups[k].segments[l].isInLegend = true;
                                        configuration.legend[i].isTitled = true;
                                    } 
                                    else
                                        configuration.barData[j].segmentGroups[k].segments[l].duplicateColor = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        this.attributeList = await data.getAllAttributes('', true);
    },
    computed: {
        validated() {
            let configuration = this.$parent.mediaProperty.configuration;
            return(
                configuration.width &&
                (configuration.majorTicks || configuration.majorTicks === 0) &&
                configuration.majorTicks >= 0 &&
                (configuration.minorTicks || configuration.minorTicks === 0) &&
                configuration.minorTicks >= 0 &&
                (configuration.minValue || configuration.minValue === 0) &&
                (configuration.maxValue || configuration.maxValue === 0) &&
                configuration.barData &&
                configuration.barData.length > 0 &&
                this.legendValidated &&
                this.barDataValidated
            )
        },
        legendValidated() {
            let configuration = this.$parent.mediaProperty.configuration;
            let ret = true;
            let legendColors = [];
            for(let l = 0; l < configuration.legend.length; l++) {
                // Check that required fields have values
                if(!configuration.legend[l].title ||
                    !configuration.legend[l].color ||
                    configuration.legend[l].title.length === 0 ||
                    configuration.legend[l].color.length === 0)
                    ret = false;
                // Check for duplicate colors
                if(legendColors.indexOf(configuration.legend[l].color) < 0)
                    legendColors.push(configuration.legend[l].color)
                else
                    ret = false;
            }
            return ret;
        },
        barDataValidated() {
            let configuration = this.$parent.mediaProperty.configuration;
            let ret = true;
            let legendColors = [];
            for(let i = 0; i < configuration.legend.length; i++) {
                if(legendColors.indexOf(configuration.legend[i].color) < 0)
                    legendColors.push(configuration.legend[i].color);
            }
            for (let i = 0; i < configuration.barData.length; i++) {
                // Check that required fields have values
                if(!(configuration.barData[i].sequence >= 0))
                    ret = false;
                for(let j = 0; j < configuration.barData[i].segmentGroups.length; j++) {
                    // Check that required fields have values
                    if(configuration.barData[i].segmentGroups[j].sequence < 0 || 
                        !configuration.barData[i].segmentGroups[j].title)
                        ret = false;
                    for(let k = 0; k < configuration.barData[i].segmentGroups[j].segments.length; k++) {
                        // Check that required fields have values
                        if(!(configuration.barData[i].segmentGroups[j].segments[k].sequence >= 0))
                            ret = false;
                        // Check that required fields have values
                        if(!(configuration.barData[i].segmentGroups[j].segments[k].startValue || 
                            configuration.barData[i].segmentGroups[j].segments[k].endValue || 
                            configuration.barData[i].segmentGroups[j].segments[k].color))
                            ret = false;
                        // Check if segments are out of max range
                        if(configuration.barData[i].segmentGroups[j].segments[k].startValue < configuration.minValue) {
                            ret = false;
                            configuration.barData[i].segmentGroups[j].segments[k].startValueTooLow = true;
                        } else {
                            configuration.barData[i].segmentGroups[j].segments[k].startValueTooLow = false;
                        }
                        if(configuration.barData[i].segmentGroups[j].segments[k].endValue > configuration.maxValue) {
                            ret = false;
                            configuration.barData[i].segmentGroups[j].segments[k].endValueTooHigh = true;
                        } else {
                            configuration.barData[i].segmentGroups[j].segments[k].endValueTooHigh = false;
                        }   
                    }
                }
            }
            return ret;
        }
    },
    methods: {
        saveBarChart: async function() {
            let configuration = this.$parent.mediaProperty.configuration;
            configuration.legend = [];
            if(configuration.barData) {
                for(let i = 0; i < configuration.barData.length; i++) {
                    for(let j = 0; j < configuration.barData[i].segmentGroups.length; j++) {
                        for(let k = 0; k < configuration.barData[i].segmentGroups[j].segments.length; k++){
                            let legendRow = configuration.legend.find(lr => lr.color === configuration.barData[i].segmentGroups[j].segments[k].color);
                            if(!legendRow && configuration.barData[i].segmentGroups[j].segments[k].isInLegend) {
                                configuration.legend.push({
                                    color: configuration.barData[i].segmentGroups[j].segments[k].color,
                                    title: configuration.barData[i].segmentGroups[j].segments[k].legendRowTitle
                                });
                                configuration.barData[i].segmentGroups[j].segments[k].duplicateColor = false;
                            }   
                            else
                                configuration.barData[i].segmentGroups[j].segments[k].duplicateColor = true;
                        }
                    }
                }
            }

            if(this.validated) {
                const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
                if(!this.$parent.mediaProperty.id && resp.id) {
                    this.$parent.mediaProperty.id = resp.id;
                    this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
                }
            } else {
                this.$toast.error('Bar Chart Not Valid');
            }
        },
        sequenceMinus: function(obj, parentArr) {
            if(!parentArr)
                parentArr = this.$parent.mediaProperty.configuration.barData;
            for(let i = 0; i < parentArr.length; i++) {
                if(parentArr[i].sequence === (obj.sequence - 1))
                    parentArr[i].sequence++;
            }
            if(obj.sequence > 1)
                obj.sequence --;
            parentArr.sort((a,b) => {return a.sequence - b.sequence;});
            this.saveBarChart();
        },
        sequencePlus: function(obj, parentArr) {
            if(!parentArr)
                parentArr = this.$parent.mediaProperty.configuration.barData;
            for(let i = 0; i < parentArr.length; i++) {
                if(parentArr[i].sequence === (obj.sequence + 1))
                    parentArr[i].sequence--;
            }
            if(obj.sequence < parentArr.length)
                obj.sequence ++;
            parentArr.sort((a,b) => {return a.sequence - b.sequence;});
            this.saveBarChart();
        },
        addBar: function() {
            if(!this.$parent.mediaProperty.configuration.barData) this.$parent.mediaProperty.configuration.barData = [];
            const newSequence = this.$parent.mediaProperty.configuration.barData.length > 0 ? this.$parent.mediaProperty.configuration.barData[this.$parent.mediaProperty.configuration.barData.length - 1].sequence + 1 : 1;
            this.$parent.mediaProperty.configuration.barData.push({
                sequence: newSequence,
                segmentGroups: []
            });
            this.saveBarChart();
        },
        deleteBar: function(barIndex) {
            if(confirm('Are you sure you want to delete this Bar?')){
                this.$parent.mediaProperty.configuration.barData.splice(barIndex, 1);
                this.saveBarChart();
            }
        },
        addSegmentGroup: function(barIndex) {
            const newSequence = this.$parent.mediaProperty.configuration.barData[barIndex].segmentGroups.length > 0 ? this.$parent.mediaProperty.configuration.barData[barIndex].segmentGroups[this.$parent.mediaProperty.configuration.barData[barIndex].segmentGroups.length - 1].sequence + 1 : 1;
            this.$parent.mediaProperty.configuration.barData[barIndex].segmentGroups.push({
                sequence: newSequence,
                segments: []
            });
            this.saveBarChart();
        },
        deleteSegmentGroup: function(barIndex, segmentGroupIndex) {
            if(confirm('Are you sure you want to delete this Segment Group?')) {
                this.$parent.mediaProperty.configuration.barData[barIndex].segmentGroups.splice(segmentGroupIndex, 1);
                this.saveBarChart();
            }
        },
        addSegment: function(barIndex, segmentGroupIndex) {
            const newSequence = this.$parent.mediaProperty.configuration.barData[barIndex].segmentGroups[segmentGroupIndex].segments.length > 0 ? this.$parent.mediaProperty.configuration.barData[barIndex].segmentGroups[segmentGroupIndex].segments[this.$parent.mediaProperty.configuration.barData[barIndex].segmentGroups[segmentGroupIndex].segments.length - 1].sequence + 1 : 1;
            this.$parent.mediaProperty.configuration.barData[barIndex].segmentGroups[segmentGroupIndex].segments.push({
                sequence: newSequence
            });
            this.saveBarChart();
        },
        deleteSegment: function(barIndex, segmentGroupIndex, segmentIndex) {
            if(confirm('Are you sure you want to delete this Segment?')) {
                this.$parent.mediaProperty.configuration.barData[barIndex].segmentGroups[segmentGroupIndex].segments.splice(segmentIndex, 1);
                this.saveBarChart();
            }
        },
        autoCompleteSubmit: function(obj, newValue) {
            this.updateAutoCompleteValue(obj, newValue);
            this.saveBarChart();
        },
        updateAutoCompleteValue: function(passedObject, newValue) {
            passedObject.obj[passedObject.property] = newValue;
        }
    }
}
</script>